import { createFileRoute } from "@tanstack/react-router";
import SpravatoWhatToExpect from "@/pages/SpravatoWhatToExpect";
export const Route = createFileRoute("/spravato-what-to-expect")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Spravato What To Expect | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "What to expect during a SPRAVATO session: nasal spray, monitoring, and recovery time at Neuro Wellness TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:title",
          content: "Spravato What To Expect | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "What to expect during a SPRAVATO session: nasal spray, monitoring, and recovery time at Neuro Wellness TMS in Coral Springs, FL Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/spravato-what-to-expect",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/spravato-what-to-expect",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <SpravatoWhatToExpect />;
}
